module.exports = __webpack_public_path__ + "static/media/14Demo Photo-ink-min.b52176eb.jpeg";